
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Upload} from '@/layouts/back-office/elements/upload/Uploader.vue';
import Spinner from '@/layouts/back-office/elements/Spinner.vue';
import ButtonSpinner from '@/layouts/back-office/elements/SpinnerButton.vue';

@Component({
  components: {Spinner, ButtonSpinner},
})
export default class ImageUploadThumb extends Vue {
  @Prop(Object) protected upload?: Upload;
  @Prop(String) protected url?: string;
  @Prop({ type: Boolean, default: false}) protected canOpen!: boolean;
  @Prop({ type: Boolean, default: true}) protected canRemove!: boolean;
  @Prop({ type: String, default: 'Image'}) protected alt!: boolean;

  private isLoading: boolean = false;

  private get displayUrl() {
    if (this.url) {
      return this.url;
    } else if (this.upload) {
      return this.upload.dataUrl || this.upload.data.url || null;
    }

    return null;
  }

  private get video() {
    if (this.displayUrl) {
      switch (this.displayUrl.substr(-3)) {
        case '.qt':
          return 'video/quicktime';
        case 'mp4':
          return 'video/mp4';
      }
    }

    return false;
  }

  get loading() {
    return this.isLoading || (typeof this.upload !== 'undefined' && this.upload.status === 'uploading');
  }

  private remove() {
    this.isLoading = true;

    this.$emit('remove');
  }

  private open(event: Event) {
    this.$emit('open');
  }

  @Watch('url')
  @Watch('upload')
  private onFileChange() {
    this.isLoading = false;
  }
}
